/*
 * @Description: 导航数据
 * @Author: ywl
 * @Date: 2021-03-29 16:33:24
 * @LastEditors: lks
 * @LastEditTime: 2021-12-04 17:02:13
 */
const list = {
  // 问卷调研
  questionnaire: [
    // {
    //   id: 300,
    //   parentId: 0,
    //   name: "新建",
    //   icon: "el-icon-circle-plus-outline",
    //   url: "",
    // },

    {
      id: 300,
      parentId: 0,
      name: '管理',
      type: 1,
      engName: 'tp_glht',
      icon: require('../../assets/img/tp_glht1.png'),
      iconAcite: require('../../assets/img/tp_glht1_click.png'),
      // url: "/questionnaire/list.html",
      url: '/activeManagement.html',
    },
    {
      id: 310,
      parentId: 0,
      name: '创建',
      type: 2,
      engName: 'tp_xj',
      icon: require('../../assets/img/tp_xj.png'),
      iconAcite: require('../../assets/img/tp_xj_click.png'),
      url: '/questionnaire/create.html',
    },
    {
      id: 330,
      parentId: 0,
      name: '模板库',
      type: 3,
      engName: 'tp_mb',
      icon: require('../../assets/img/tp_mb.png'),
      iconAcite: require('../../assets/img/tp_mb_click.png'),
      url: '/questionnaire/templateLibrarySurvey.html',
    },
    {
      id: 340,
      parentId: 0,
      name: '我填写的',
      type: 5,
      engName: 'tp_wtxd',
      icon: require('../../assets/img/tp_wtxd.png'),
      iconAcite: require('../../assets/img/tp_wtxd_click.png'),
      url: '/questionnaire/writeRecord.html',
    },
    {
      id: 320,
      parentId: 0,
      name: '回收站',
      type: 4, // 4 类型为回收站
      engName: 'tp_hs',
      icon: require('../../assets/img/tp_hs.png'),
      iconAcite: require('../../assets/img/tp_hs_click.png'),
      url: '/questionnaire/delete.html',
    },
    // {
    //   id: 350,
    //   parentId: 0,
    //   name: '联系人',
    //   type: 5,
    //   engName: 'tp_hs',
    //   icon: require('../../assets/img/tp_hs.png'),
    //   iconAcite: require('../../assets/img/tp_hs_click.png'),
    //   url: '/email.html',
    // },
  ],
  // 投票
  voting: [
    {
      id: 400,
      parentId: 0,
      name: '管理',
      type: 1,
      engName: 'tp_glht',
      icon: require('../../assets/img/tp_glht1.png'),
      iconAcite: require('../../assets/img/tp_glht1_click.png'),
      // url: "/voting/list.html",
      url: '/activeManagement.html',
    },
    {
      id: 410,
      parentId: 0,
      name: '创建',
      type: 2,
      engName: 'tp_xj',
      icon: require('../../assets/img/tp_xj.png'),
      iconAcite: require('../../assets/img/tp_xj_click.png'),
      url: '/voting/create.html',
    },
    {
      id: 430,
      parentId: 0,
      name: '模板库',
      type: 3,
      engName: 'tp_mb',
      icon: require('../../assets/img/tp_mb.png'),
      iconAcite: require('../../assets/img/tp_mb_click.png'),
      url: '/voting/templateLibrary.html',
    },
    {
      id: 420,
      parentId: 0,
      name: '回收站',
      type: 4,
      engName: 'tp_hs',
      icon: require('../../assets/img/tp_hs.png'),
      iconAcite: require('../../assets/img/tp_hs_click.png'),
      url: '/voting/delete.html',
    },
    // {
    //   id: 450,
    //   parentId: 0,
    //   name: '联系人',
    //   type: 5,
    //   engName: 'tp_hs',
    //   icon: require('../../assets/img/tp_hs.png'),
    //   iconAcite: require('../../assets/img/tp_hs_click.png'),
    //   url: '/email.html',
    // },
  ],

  article: [
    {
      id: 600,
      parentId: 0,
      name: '帮助与支持',
      icon: 'el-icon-s-home',
      url: '/help.html',
    },
  ],
  template: [
    {
      id: 700,
      parentId: 0,
      name: '模板案例',
      icon: 'el-icon-s-home',
      url: '/template/list.html',
    },
  ],
  // 考试测评
  questionnaireExam: [
    {
      id: 900,
      parentId: 0,
      name: '管理',
      type: 1,
      engName: 'tp_glht',
      icon: require('../../assets/img/tp_glht1.png'),
      iconAcite: require('../../assets/img/tp_glht1_click.png'),
      // url: "/questionnaire/exam.html",
      url: '/activeManagement.html',
    },
    {
      id: 910,
      parentId: 0,
      name: '创建',
      type: 2,
      engName: 'tp_xj',
      icon: require('../../assets/img/tp_xj.png'),
      iconAcite: require('../../assets/img/tp_xj_click.png'),
      url: '/questionnaire/create.html',
    },
    {
      id: 930,
      parentId: 0,
      name: '模板库',
      type: 3,
      engName: 'tp_mb',
      icon: require('../../assets/img/tp_mb.png'),
      iconAcite: require('../../assets/img/tp_mb_click.png'),
      url: '/questionnaire/templateLibraryExam.html',
    },
    {
      id: 940,
      parentId: 0,
      name: '我填写的',
      type: 5,
      engName: 'tp_wtxd',
      icon: require('../../assets/img/tp_wtxd.png'),
      iconAcite: require('../../assets/img/tp_wtxd_click.png'),
      url: '/questionnaire/writeRecord.html',
    },
    {
      id: 920,
      parentId: 0,
      name: '回收站',
      type: 4,
      engName: 'tp_hs',
      icon: require('../../assets/img/tp_hs.png'),
      iconAcite: require('../../assets/img/tp_hs_click.png'),
      url: '/questionnaire/deleteExam.html',
    },
    // {
    //   id: 950,
    //   parentId: 0,
    //   name: '联系人',
    //   type: 5,
    //   engName: 'tp_hs',
    //   icon: require('../../assets/img/tp_hs.png'),
    //   iconAcite: require('../../assets/img/tp_hs_click.png'),
    //   url: '/email.html',
    // },
  ],
  // 表单
  questionnaireForm: [
    {
      id: 1000,
      parentId: 0,
      name: '管理',
      type: 1,
      engName: 'tp_glht',
      icon: require('../../assets/img/tp_glht1.png'),
      iconAcite: require('../../assets/img/tp_glht1_click.png'),
      // url: "/questionnaire/form.html",
      url: '/activeManagement.html',
    },
    {
      id: 1010,
      parentId: 0,
      name: '创建',
      type: 2,
      engName: 'tp_xj',
      icon: require('../../assets/img/tp_xj.png'),
      iconAcite: require('../../assets/img/tp_xj_click.png'),
      url: '/questionnaire/create.html',
    },
    {
      id: 1030,
      parentId: 0,
      name: '模板库',
      type: 3,
      engName: 'tp_mb',
      icon: require('../../assets/img/tp_mb.png'),
      iconAcite: require('../../assets/img/tp_mb_click.png'),
      url: '/questionnaire/templateLibraryForm.html',
    },
    {
      id: 1040,
      parentId: 0,
      name: '我填写的',
      type: 5,
      engName: 'tp_wtxd',
      icon: require('../../assets/img/tp_wtxd.png'),
      iconAcite: require('../../assets/img/tp_wtxd_click.png'),
      url: '/questionnaire/writeRecord.html',
    },
    {
      id: 1020,
      parentId: 0,
      name: '回收站',
      type: 4,
      engName: 'tp_hs',
      icon: require('../../assets/img/tp_hs.png'),
      iconAcite: require('../../assets/img/tp_hs_click.png'),
      url: '/questionnaire/deleteForm.html',
    },
    // {
    //   id: 1050,
    //   parentId: 0,
    //   name: '联系人',
    //   type: 5,
    //   engName: 'tp_hs',
    //   icon: require('../../assets/img/tp_hs.png'),
    //   iconAcite: require('../../assets/img/tp_hs_click.png'),
    //   url: '/email.html',
    // },
  ],
  // 在线接龙
  questionnaireSolitaire: [
    {
      id: 1400,
      parentId: 0,
      name: '管理',
      type: 1,
      engName: 'tp_glht',
      icon: require('../../assets/img/tp_glht1.png'),
      iconAcite: require('../../assets/img/tp_glht1_click.png'),
      // url: "/questionnaire/form.html",
      url: '/activeManagement.html',
    },
    {
      id: 1410,
      parentId: 0,
      name: '创建',
      type: 2,
      engName: 'tp_xj',
      icon: require('../../assets/img/tp_xj.png'),
      iconAcite: require('../../assets/img/tp_xj_click.png'),
      url: '/questionnaire/create.html',
    },
    {
      id: 1430,
      parentId: 0,
      name: '模板库',
      type: 3,
      engName: 'tp_mb',
      icon: require('../../assets/img/tp_mb.png'),
      iconAcite: require('../../assets/img/tp_mb_click.png'),
      url: '/questionnaire/templateLibrarySolitaire.html',
    },
    {
      id: 1440,
      parentId: 0,
      name: '我填写的',
      type: 5,
      engName: 'tp_wtxd',
      icon: require('../../assets/img/tp_wtxd.png'),
      iconAcite: require('../../assets/img/tp_wtxd_click.png'),
      url: '/questionnaire/writeRecord.html',
    },
    {
      id: 1420,
      parentId: 0,
      name: '回收站',
      type: 4,
      engName: 'tp_hs',
      icon: require('../../assets/img/tp_hs.png'),
      iconAcite: require('../../assets/img/tp_hs_click.png'),
      url: '/questionnaire/deleteSolitaire.html',
    },
    // {
    //   id: 1450,
    //   parentId: 0,
    //   name: '联系人',
    //   type: 5,
    //   engName: 'tp_hs',
    //   icon: require('../../assets/img/tp_hs.png'),
    //   iconAcite: require('../../assets/img/tp_hs_click.png'),
    //   url: '/email.html',
    // },
  ],
  // 在线收款
  questionnaireOnline: [
    {
      id: 1500,
      parentId: 0,
      name: '管理',
      type: 1,
      engName: 'tp_glht',
      icon: require('../../assets/img/tp_glht1.png'),
      iconAcite: require('../../assets/img/tp_glht1_click.png'),
      // url: "/questionnaire/form.html",
      url: '/activeManagement.html',
    },
    {
      id: 1510,
      parentId: 0,
      name: '创建',
      type: 2,
      engName: 'tp_xj',
      icon: require('../../assets/img/tp_xj.png'),
      iconAcite: require('../../assets/img/tp_xj_click.png'),
      url: '/questionnaire/create.html',
    },
    {
      id: 1530,
      parentId: 0,
      name: '模板库',
      type: 3,
      engName: 'tp_mb',
      icon: require('../../assets/img/tp_mb.png'),
      iconAcite: require('../../assets/img/tp_mb_click.png'),
      url: '/questionnaire/templateLibraryOnline.html',
    },
    {
      id: 1540,
      parentId: 0,
      name: '我填写的',
      type: 5,
      engName: 'tp_wtxd',
      icon: require('../../assets/img/tp_wtxd.png'),
      iconAcite: require('../../assets/img/tp_wtxd_click.png'),
      url: '/questionnaire/writeRecord.html',
    },
    {
      id: 1520,
      parentId: 0,
      name: '回收站',
      type: 4,
      engName: 'tp_hs',
      icon: require('../../assets/img/tp_hs.png'),
      iconAcite: require('../../assets/img/tp_hs_click.png'),
      url: '/questionnaire/deleteOnline.html',
    },
    // {
    //   id: 1550,
    //   parentId: 0,
    //   name: '联系人',
    //   type: 5,
    //   engName: 'tp_hs',
    //   icon: require('../../assets/img/tp_hs.png'),
    //   iconAcite: require('../../assets/img/tp_hs_click.png'),
    //   url: '/email.html',
    // },
  ],
  // 在线预约
  questionnaireAppoint: [
    {
      id: 1600,
      parentId: 0,
      name: '管理',
      type: 1,
      engName: 'tp_glht',
      icon: require('../../assets/img/tp_glht1.png'),
      iconAcite: require('../../assets/img/tp_glht1_click.png'),
      // url: "/questionnaire/form.html",
      url: '/activeManagement.html',
    },
    {
      id: 1610,
      parentId: 0,
      name: '创建',
      type: 2,
      engName: 'tp_xj',
      icon: require('../../assets/img/tp_xj.png'),
      iconAcite: require('../../assets/img/tp_xj_click.png'),
      url: '/questionnaire/create.html',
    },
    {
      id: 1630,
      parentId: 0,
      name: '模板库',
      type: 3,
      engName: 'tp_mb',
      icon: require('../../assets/img/tp_mb.png'),
      iconAcite: require('../../assets/img/tp_mb_click.png'),
      url: '/questionnaire/templateLibraryAppoint.html',
    },
    {
      id: 1640,
      parentId: 0,
      name: '我填写的',
      type: 5,
      engName: 'tp_wtxd',
      icon: require('../../assets/img/tp_wtxd.png'),
      iconAcite: require('../../assets/img/tp_wtxd_click.png'),
      url: '/questionnaire/writeRecord.html',
    },
    {
      id: 1620,
      parentId: 0,
      name: '回收站',
      type: 4,
      engName: 'tp_hs',
      icon: require('../../assets/img/tp_hs.png'),
      iconAcite: require('../../assets/img/tp_hs_click.png'),
      url: '/questionnaire/deleteAppoint.html',
    },
    // {
    //   id: 1650,
    //   parentId: 0,
    //   name: '联系人',
    //   type: 5,
    //   engName: 'tp_hs',
    //   icon: require('../../assets/img/tp_hs.png'),
    //   iconAcite: require('../../assets/img/tp_hs_click.png'),
    //   url: '/email.html',
    // },
  ],
  apply: [],
};

export default list;
